import React from "react";
import { Settings as SettingsComponent } from "../components/settings/Settings";

const Settings = () => {
  return <SettingsComponent />;
};

export default Settings;
